import React, { useState } from "react";
import Header from "../../components/Header/Header";
import NavBar from "../../components/NevBar/Navigation";
import Search from "../../components/CustSearch/Search";
import Filterdata from "../../components/ChildData/Filterdata";
// import { useAuth } from "../../context/AuthContext";
import Accordion from "../../components/accordion/Insites";
import WaterMark from "../../components/WaterMark";
function Landing() {
  const [title, setHeaderTitle] = useState("Customer360");

  return (
    <div className="relative bg-[#F3F3F3] min-h-screen overflow-hidden">
      {/* <PipelineServicesProvider> */}
      <WaterMark />
      {/* Fixed Header */}
      <Header title={title} />

      <div className="mt-2 mr-2  w-full bg-white rounded-4xl shadow-md rounded-[10px] border-gray-300">
        <div className="px-2">
          <Search />
        </div>
        <div className=" bg-[#F3F3F3] p-0">
          <Filterdata />
        </div>
      </div>
      {/* </PipelineServicesProvider> */}
    </div>
  );
}

export default Landing;
